<template>
    <div class="flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <Toast />
        <loading
            :active="isLoadingModel"
            :can-cancel="true"
            color="#173EA3"
            :is-full-page="fullPage"
        ></loading>

        <div class="flex flex-column align-items-center justify-content-center pb-5">
            <img src="/images/banner.png" alt="sbm logo" class="mb-6 w-full mt-0" />

            <div class="text-center">
                <div class="w-full surface-card py-7 px-2 sm:px-8" style="border-radius: 10px; border:1px solid #5BBC66; border-radius:10px;"> 
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="card-img text-center" style="margin-top:10%;">
                                <img class="" style="align:center!important; width:100%;" src="/images/sbm_img.png"  >
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="card-fields">
                                <label for="email" class="block text-900 text-xl font-medium mb-2" style="text-align:left">Username</label>
                                <InputText id="email" v-model="email" type="text" class="w-full mb-3" placeholder="Username" style="padding:1rem;" />

                                <label for="password" class="block text-900 font-medium text-xl mb-2" style="text-align:left">Password</label>
                                <InputText  id="password" v-model="password" type="password" class="w-full mb-3" placeholder="Password" style="padding:1rem;" @keypress.enter="Login" />

                                <Button label="Sign In" style="background-color:#22C55E" class="w-full p-3 text-xl" @click="Login"> </button>
                            </div>
                        </div>

                    </div>                 
                    <div class="flex align-items-center justify-content-between mb-5 gap-7"> <a class="">.</a></div>          
                </div>
            </div>
        </div>
    </div>
</template>

<!-- <template>
    <div class="grid" style="height: 10%;">
    <img width="1700" height="150" src="/images/banner.png" alt="">
  </div>
    <div  class="surface-0  align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <Toast />
        <loading
    :active="isLoadingModel"
    :can-cancel="true"
     color="#173EA3"
    :is-full-page="fullPage"
  ></loading>
  
  <div  class="grid justify-content-center p-2 lg:p-0;" style="min-width:80%;margin-top: 20px;">
            
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
            <div class="col-4 mt-4 xl:mt-0 text-center" style="border-radius:10px 0 0 10px; padding:0.3rem;border:1px solid #5BBC66;height:400px;border-right:0px; text-align:center">
                
                 <br><br>
                 <img class="" style="align:center!important;width:300px;margin-top: 50px;" src="/images/sbm_img.png"  > 
                
            </div>
            <div class="col-4 xl:col-4" style="border-radius:0 10px 10px 0; padding:0.3rem;border:1px solid #5BBC66;border-left:0px">
                <div class="grid">
                    <div class="col-12 xl:col-12" style="text-align:center">
                        
                    </div>
                    <div class="col-12 xl:col-12" style="margin-top:50px">
                <div class="" style=" background: transparent">
                    
                    
                    <div class="w-full md:w-10 mx-auto">
                        <label for="email1" class="block text-900 text-xl font-medium mb-2">Username</label>
                        <InputText id="email1" v-model="email" type="text" class="w-full mb-3" placeholder="Username" style="padding:1rem;" />
                       
                        <label for="password1" class="block text-900 font-medium text-xl mb-2">Password</label>
                        <InputText  id="password1" v-model="password" type="password" class="w-full mb-3" placeholder="Password" style="padding:1rem;" @keypress.enter="Login" />
                        
                        <div class="flex align-items-center justify-content-between mb-5">
                            <div class="flex align-items-center">                               
                            </div>
                             </div>
                        <Button label="Sign In" style="background-color:#22C55E" class="w-full p-3 text-xl" @click="Login"> </button>
                    </div>
                </div>
                
                    </div>
                </div>
                
            </div>
        </div>
  </div>
    </div>
</template> -->



<script>
import apis from "@/apis";
export default {
    data() {
        return {
            isLoadingModel:false,
			fullPage:true,
            email: '',
            password: '',
            checked: false,
            show:false,
            user_type:'',
        }
    },
    methods:{
    async  Login()
      {
        
        if(this.email==="" ||this.email===null ||this.email===undefined)
        {
            //alert("Please Enter Username");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Username', life: 3000});
            return false;
        }
        if(this.password==="" ||this.password===null ||this.password===undefined)
        {
            //alert("Please Enter Password");
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Please Enter Password', life: 3000});
            return false;
        }
        
        var data = 
         {
                "email_id":this.email,  
                "password":this.password, 
         };
         this.isLoadingModel = true;
		var promise = apis.login(data);
        promise
        .then(response => { 
            this.isLoadingModel = false;
        if(response.data.status==true)
        {   
            localStorage.clear();
            
            localStorage.user_key = response.data.data[0].user_type;
            localStorage.id = response.data.data[0]._id;
            localStorage.token = response.data.data[0].logintoken;
            localStorage.client_id = response.data.data[0].client_id?response.data.data[0].client_id:'';

            localStorage.state_code     = response.data.data[0].state_code      ?response.data.data[0].state_code:[];
            localStorage.district_id    = response.data.data[0].district_id     ?response.data.data[0].district_id:[];
            localStorage.block_id       = response.data.data[0].block_id        ?response.data.data[0].block_id:[];
            localStorage.panchayat_id    = response.data.data[0].panchayat_id     ?response.data.data[0].panchayat_id:[];
            localStorage.village_id     = response.data.data[0].village_id      ?response.data.data[0].village_id:[];           

            localStorage.client_name = '';
           
            if (response.data.data[0].client_details && response.data.data[0].client_details.length>0) 
            {
                localStorage.client_name = response.data.data[0].client_details[0].description;
            }
            if (response.data.data[0].client_group_details && response.data.data[0].client_group_details.length>0) 
            {   
                localStorage.client_name = response.data.data[0].client_group_details[0].group_name;
                localStorage.group_name = response.data.data[0].client_group_details[0].group_name;
               
                //localStorage.client_group_ids=response.data.data[0].client_group_details[0].client_ids;
                localStorage.setItem('client_group_ids', JSON.stringify(response.data.data[0].client_group_details[0].client_ids));
                
            }
            else
            {
                localStorage.setItem('client_group_ids', '');
            }
            
            //for fleet manager
            localStorage.role_id = response.data.data[0].role_id[0].role_id;

            localStorage.setItem('user_profile',JSON.stringify(response.data.data[0]));

            
            this.$store.dispatch("setClients",   response.data.data[0]);
            this.$store.dispatch("setUserTypes", response.data.data[0].client_id);           
            this.$store.dispatch("setDistricts", response.data.data[0]);
            this.$store.dispatch("setBlocks",    []);
            // this.$store.dispatch("setPanchyats", []);
            this.$store.dispatch("setGarbageCenterType", []);
            //this.$store.dispatch("setVillages",  response.data.data[0]); // api error for all village data 
            
            var dashboard_link="";
           if (response.data.data[0].role_id && response.data.data[0].role_id[0].dashboard_link) 
           {  
             dashboard_link=response.data.data[0].role_id[0].dashboard_link.toString();

            localStorage.Breadcrumb_home = dashboard_link;  //for Breadcrumb_home

            this.$router.push({name:dashboard_link});
            
           }
           else
           {
              dashboard_link = '/dashboard';                    //for Breadcrumb_home
              localStorage.Breadcrumb_home = dashboard_link;    //for Breadcrumb_home

            this.$router.push('/dashboard');
           }
            


            //*****************************************************************************************************
            // if(this.user_type.value == "admin")
            // {
            //      localStorage.token = response.data["token"]; // user type id
            //      localStorage.id = response.data.admindata["admiN_ID"];
            //      localStorage.full_name = response.data.admindata["firsT_NAME"];  
            //      localStorage.email = response.data.admindata["email"]; 
            //     //  this.$session.start();
            //     // this.$session.set("token", token);
               
            //     this.$router.push('/dashboard');
            // }
            // else if(this.user_type.value == "teacher") 
            // {
            //      localStorage.token = response.data["token"];
            //      localStorage.id = response.data.teacherdata["teacheR_ID"];
            //      localStorage.full_name = response.data.teacherdata["firsT_NAME"];
            //      localStorage.email = response.data.teacherdata["email"]; 

            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'Teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/teacherhome');
            // }
            // else if(this.user_type.value == "assteacher") 
            // {      
            //     localStorage.id = response.data.teacherdata["teacheR_ID"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.teacherdata["firsT_NAME"];
            //     localStorage.email = response.data.teacherdata["email"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/ateacherhome');
            // }
            // else if(this.user_type.value == "network") 
            // {      
            //     localStorage.id = response.data.networkuserdata["id"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.networkuserdata["name"];
            //     localStorage.email = response.data.networkuserdata["email"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/dashboard');
            // }
            // else if(this.user_type.value == "student") 
            // {      
            //     localStorage.id = response.data.studentdata["studenT_ID"];
            //     localStorage.token = response.data["token"];
            //     localStorage.full_name = response.data.studentdata["firsT_NAME"]+" "+response.data.studentdata["surname"];
            //     localStorage.email = response.data.studentdata["email"]; 
            //     localStorage.mobile = response.data.studentdata["mobile"]; 
            //     // this.$session.start();
            //     // this.$session.set("user_login_type", 'assistant_teacher');
            //     // this.$session.set("user_type", this.user_type.value);
            //     this.$router.push('/studentdashboard');
            // }
        } 
        else  
        {
              this.$toast.add({severity:'error', summary: 'Error Message', detail:response.data.message, life: 3000});
            return false;
        }  
            
            
        })
        .catch(error => {
            this.isLoadingModel = false;
            this.$toast.add({severity:'error', summary: 'Error Message', detail:'Invalid Login Credentials', life: 3000});
            return false;
            });
      }  
    },
    computed: {
        logoColor() {
            if (this.$appState.darkTheme) return 'white';
            return 'dark';
        }
    }
}
</script>

<style scoped>
.pi-eye {
    transform:scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform:scale(1.6);
    margin-right: 1rem;
}
</style>